import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {WebMetricsService} from '../../core/services/web-metrics/web-metrics.service';
import {TranslateService} from '@ngx-translate/core';
import {DipRegistrationContextService} from '../../core/services/dip-registration-context.service';
import {DipRegistrationConfirmService} from '../../core/services/dip-registration-confirm.service';
import { DipRegistrationNavigationService } from '../../core/services/dip-registration-navigation.service';
import { DiprsSpaLoggerService } from '../../core/services/logger/diprs-spa-logger.service';
import { DipRegistrationLoggingNames } from '../../core/enum/dip-registration-logging-names.enum';
import { LoggerEventEnum } from '../../core/models/dip-registration-log-information.model';
import {WebMetricsEvent} from '../../core/services/web-metrics/web-metrics.constants';

@Component({
    selector: 'dip-registration-application-error',
    templateUrl: './dip-registration-application-error.component.html',
    styleUrls: ['./dip-registration-application-error.component.scss'],
    standalone: false
})
export class DipRegistrationApplicationErrorComponent implements OnInit, OnDestroy {

  errorCode: string;
  errorMessage: string;
  errorTitle: string;
  phoneNumber: string;
  version: string;
  sessionId: string;
  type: string;

  constructor(private route: ActivatedRoute,
              private dipRegistrationContextService: DipRegistrationContextService,
              private webMetricsService: WebMetricsService,
              private dipRegistrationConfirmService: DipRegistrationConfirmService,
              private translateService: TranslateService,
              private dipRegistrationNavigationService: DipRegistrationNavigationService,
              private spaLoggerService: DiprsSpaLoggerService) {
  }

  async ngOnInit() {
    this.spaLoggerService.info(LoggerEventEnum.PAGE_ENTERED, DipRegistrationLoggingNames.APPLICATION_ERROR, { previousPageId: this.dipRegistrationNavigationService.getPreviousUrl() });
    this.dipRegistrationConfirmService.stop();
    this.phoneNumber = this.dipRegistrationContextService.getPhoneNumber();
    this.errorCode = this.route?.snapshot?.queryParams?.errorCode ? this.route.snapshot.queryParams.errorCode : 'generic';
    this.type = this.route?.snapshot?.queryParams?.type ? this.route.snapshot.queryParams.type : 'internal';
    // error tile
    const errorTitleKey = `DIPRSRegistration.error.${this.errorCode}.title`;
    this.errorTitle = this.translateService.instant(errorTitleKey);
    this.errorTitle = this.errorTitle === errorTitleKey ?
      this.translateService.instant('DIPRSRegistration.error.generic.title', {phoneNumber: this.phoneNumber}) : this.errorTitle;

    // error message
    const errorMessageKey = `DIPRSRegistration.error.${this.errorCode}.message`;
    this.errorMessage = this.translateService.instant(errorMessageKey, {phoneNumber: this.phoneNumber});
    this.errorMessage = this.errorMessage === errorMessageKey ?
    this.translateService.instant('DIPRSRegistration.error.generic.message', {phoneNumber: this.phoneNumber}) : this.errorMessage;

    if (this.type === 'technical') {
      this.webMetricsService.submitErrorAndWarningTag('technicalServerErrorTag', this.errorCode, this.errorMessage);
    } else if (this.type === 'functional') {
      this.webMetricsService.submitErrorAndWarningTag('functionalServerErrorTag', this.errorCode, this.errorMessage);
    } else {
      this.webMetricsService.submitErrorAndWarningTag('internalServerErrorTag', this.errorCode, this.errorMessage);
    }

    this.dipRegistrationContextService.resetContextFlag();
    this.sessionId = this.dipRegistrationContextService.getSessionId();
    this.version = this.dipRegistrationContextService.getVersionId();
  }

  ngOnDestroy() {
    this.spaLoggerService.info(LoggerEventEnum.PAGE_EXITED, DipRegistrationLoggingNames.APPLICATION_ERROR, null);
  }
}

